import { action, observable, set } from "mobx";

export default class TourClientPanelOptions {
  /**
   * @property {boolean}
   */
  @observable enableClientPanelEditing = false;

  /**
   * @property {boolean}
   */
  @observable enableClientPanelMediaUpload = false;

  /**
   * @property {boolean}
   */
  @observable allowPhotoDownload = false;

  /**
   * @property {boolean}
   */
  @observable allowPrintQualityImageDownload = false;

  /**
   * @property {boolean}
   */
  @observable allowVideoClipDownload = false;

  /**
   * @property {boolean}
   */
  @observable allowVirtualTourDownload = false;

  /**
   * @property {boolean}
   */
  @observable allowImmersive3dTourEditing = false;

  constructor(data) {
    if (data !== undefined) {
      this.setData(data);
    }
  }

  @action
  setData(data) {
    set(this, data);
  }
}
